<template>
    <router-link class="card-link" :to="{name: 'medal', params: {slug: model.id}}">
    <li class="card lift-hover">
        <img :alt="model.name" class="thumbnailImage" :src="`${$rootUrl()}${model.image}`" />
        <div class="text">
            <p class="cardHeader">{{ model.name }}</p>
            <span class="subheader"> {{ model.year }}</span>
            <div class="info">
                <div class="body summary" v-html="model.summary.slice(0, 84)"></div>
            </div>
        </div>
    </li>
    </router-link>
</template>

<script>

export default {
    name: "MedalCard",
    props: {
        model: Object
    }
}
</script>

<style scoped lang="scss">

.small-grid .card {
    max-width: 400px;
    width: initial;
}
.card {
    height: 280px;
    display: flex;
    padding: 17px;

    img.thumbnailImage {
        object-fit: contain;
        background-color: black;
        display: inline-block;
        width: auto;
        height: 100%;
        margin-right: 18px;
        min-width: 190px;
    }

    .text {
        display: inline-block;
        .cardHeader {
            margin-top: 0;
        }
    }
    .cardHeader {
        line-height: 17px;
    }

    .summary{
        line-height: 20px;
        margin-top: 10px;
    }

    .summary:after {
        content: '…';
    }
    @media screen and (max-width: 1025px) {
        .card {
            height: initial;
        }
    }
    @media screen and (max-width: 831px) {
        img.thumbnailImage {
            margin-right: 10px;
            max-width: 100px;
            min-width: initial;
        }
    }
    @media screen and (max-width: 633px) {
        img.thumbnailImage {
            margin-right: 10px;
            max-width: 180px;
            min-width: initial;
        }
    }
    @media screen and (max-width: 450px) {
        img.thumbnailImage {
            margin-right: 10px;
            min-width: initial;
            max-width: 120px;
        }

    }
}

</style>